import React from 'react';
import '../styles/ChallengeModals.css';

function ChallengeFriendlyCreate({ onCreate, onCancel }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content create-challenge-modal friendly-challenge-modal">
        <div className="modal-header">
          <h2>Friendly Challenge</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <div className="modal-body">
          <div className="summary">
            <div className="summary-row">
              <span>Wager:</span>
              <strong>0 wikipenny</strong>
            </div>
            <div className="summary-row">
              <span>Game Type:</span>
              <strong>Single Match</strong>
            </div>
            <div className="summary-row total">
              <span>Total at Risk:</span>
              <strong>0 wikipenny</strong>
            </div>
          </div>

          <div className="info-box">
            <p>✓ Friendly challenges have no wager</p>
            <p>✓ Great for practice and quick matches</p>
            <p>✓ Your opponent must accept the invite</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onCancel}>Cancel</button>
          <button
            className="btn-primary"
            onClick={() => onCreate(0, { friendly: true })}
          >
            Create Friendly Challenge
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChallengeFriendlyCreate;

